import React from 'react';
import Button from '../Button';
import Icon from '../../Icon';
import { StyledButtonDouble } from './styled';

const ButtonDouble = ({ style, disabled, children, onClickLeft, onClickRight }) => {
    return (
        <StyledButtonDouble style={style}>
            <Button transparent noMargin disabled={disabled} onClick={onClickLeft}><Icon name='arrow' width={13} height={24} color="#3C3C3C" style={{ transform: 'rotate(180deg)' }} /></Button>
            {children}
            <Button transparent noMargin disabled={disabled} onClick={onClickRight}><Icon name='arrow' width={13} height={24} color="#3C3C3C" /></Button>
        </StyledButtonDouble>
    )
}

export default ButtonDouble;
